<template>
    <div>
        <v-row class="px-container pt-10" v-if="$vuetify.breakpoint.xsOnly"
            ><h4 class="textColor">{{ $t('Профиль') }}</h4></v-row
        >
        <v-card-text :class="{ 'px-container': true, 'pt-10': $vuetify.breakpoint.smAndUp, 'pt-5': $vuetify.breakpoint.xsOnly }">
            <v-row v-if="InfoUser.serv_org_show">
                <span class="profile_user_label">{{ $t('Сервисная организация') }}</span>
            </v-row>
            <v-row class="pt-3" v-if="InfoUser.serv_org_show">
                <span class="gray--text">{{ InfoUser.serv_org_name }}</span>
            </v-row>

            <v-row v-if="InfoUser.ksk_show">
                <span class="profile_user_label">{{ $t('КСК') }}</span>
            </v-row>
            <v-row class="pt-3" v-if="InfoUser.ksk_show">
                <span class="gray--text">{{ InfoUser.isas_ksk_name }}</span>
            </v-row>

            <v-row v-if="InfoUser.contract_show">
                <span class="profile_user_label">{{ $t('Договор') }}</span>
            </v-row>
            <v-row class="pt-3" v-if="InfoUser.contract_show">
                <span class="gray--text">{{ InfoUser.contract_number }} {{ InfoUser.contractor_name }}</span>
            </v-row>

            <v-row :class="{ 'pt-7': InfoUser.serv_org_show }">
                <span class="profile_user_label">{{ $t('E-mail') }}</span>
            </v-row>
            <v-row class="pt-3">
                <span class="gray--text">{{ InfoUser.email }}</span>
            </v-row>

            <v-row class="pt-7">
                <span class="profile_user_label">{{ $t('Ф.И.О.') }}</span>
            </v-row>
            <v-row class="pt-3">
                <span class="gray--text">{{ InfoUser.user_name }}</span>
            </v-row>

            <v-row class="pt-7" v-if="InfoUser.category_show">
                <span class="profile_user_label">{{ $t('Категория пользователя') }}</span>
            </v-row>
            <v-row class="pt-3" v-if="InfoUser.category_show">
                <span class="gray--text">{{ InfoUser.category_name }}</span>
            </v-row>

            <v-row class="pt-7">
                <span class="profile_user_label">{{ $t('Роль') }}</span>
            </v-row>
            <v-row class="pt-3">
                <span class="gray--text">{{ InfoUser.role_name }}</span>
            </v-row>

            <v-row class="pt-10">
                <ChangePassword />
            </v-row>
        </v-card-text>
    </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import translate from '../../utils/translate.util';
//import LabeledCard from '../ui/LabeledCard';
import ChangePassword from '@/components/auth/ChangePassword.vue';
export default {
    components: {
        //LabeledCard,
        ChangePassword
    },
    data: () => ({
        InfoUser: {
            serv_org_name: null,
            serv_org_show: false,
            contract_show: false,
            category_show: false,
            ksk_show: false,
            email: null,
            role_name: null,
            user_name: null,
            isas_ksk_name: null,
            contract_number: null,
            contractor_name: null,
            category_name: null
        }
    }),
    computed: {
        ...mapState('users', ['userInfo']),
        InfoUserTranslated() {
            // первый параметр - данные из БД, которые нужно перевести
            // второй параметр: full - переводить всё, где встречается постфиксы ___kz или ____ru, part - переводить только label___kz или label___ru
            return translate(this.userInfo, 'full', this.$i18n.locale);
        }
    },
    methods: {
        ...mapActions('users', ['getUserInfo']),
        fillForm() {
            this.InfoUser.email = this.userInfo.email;
            this.InfoUser.user_name = this.userInfo.user_data.name ? this.userInfo.user_data.name : null;
            this.InfoUser.role_name = this.InfoUserTranslated.role_name.role_name;
            this.InfoUser.serv_org_show = this.userInfo.user_data.isas_serv_org_rid > 0;
            this.InfoUser.serv_org_name = this.InfoUserTranslated.isas_serv_org_name.isas_serv_org_name;
            this.InfoUser.contract_show = this.userInfo.user_data.isas_contract_rid > 0;
            this.InfoUser.contract_number = this.userInfo.user_data.contract_number;
            this.InfoUser.contractor_name = this.InfoUserTranslated.user_data.contractor_name;
            this.InfoUser.ksk_show = this.userInfo.user_data.isas_ksk_rid > 0;
            this.InfoUser.isas_ksk_name = this.InfoUserTranslated.user_data.isas_ksk_name;
            this.InfoUser.category_show = this.userInfo.user_data.category_rid !== null && this.userInfo.user_data.category_rid !== undefined;
            this.InfoUser.category_name = this.InfoUserTranslated.category_name.category_name;
        }
    },
    async mounted() {
        await this.getUserInfo();
        this.fillForm();
        this.$watch(
            '$i18n.locale',
            (newLocale, oldLocale) => {
                if (newLocale === oldLocale) {
                    return;
                }
                this.fillForm();
            },
            { immediate: true }
        );
    }
};
</script>

<style>
.profile_user_label {
    color: #363e59;
    font-size: 16px;
}

.profile_user_text {
    color: #000;
    font-size: 16px;
}
</style>
